__turbopack_context__.v({
  "loader": "styles-module__41cRbG__loader",
  "loading": "styles-module__41cRbG__loading",
});
